// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2Rjqe","productName":"Table_productName__2t6zq"};